import React from "react";
import { Link } from "react-router-dom";

const CTA = () => {
  return (
    <div className="cta">
      <div className="cta__main">
        <h3>Need more information or assistance?</h3>
        <p>
          Visit our contact page today for product support, enquires,
          personalized support and guidance.
        </p>
      </div>

      <Link to="/contact">
        <button className="btnAlt">Contact us</button>
      </Link>
    </div>
  );
};

export default CTA;
